import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
});
export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__SET_BRANDS`:
            return core.setBrands(state, action.brands);
        case `${env.toUpperCase()}__UPDATE_BRANDS`:
            return core.updateBrands(state, action.brands);
        case `${env.toUpperCase()}__UPDATE_BRAND`:
            return core.updateBrand(state, action.brandId, action.brand);
        case `${env.toUpperCase()}__SET_BRAND`:
            return core.setBrand(state, action.brandId, action.brand);
        case `${env.toUpperCase()}__DELETE_BRAND`:
            return core.setBrand(state, action.brandId);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Brands/reducer.js